import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
// Figma 2753:24172 は 18×18。内側の時計（2753:24173）は 14.1429×14.1429。
export const SearchHistoryClockIcon = ({ classObject }) => {
    return (React.createElement("span", { className: css(styles.slot, classObject) },
        React.createElement("img", { className: css(styles.icon), src: "/assets/images/icons/search_history_clock.svg", alt: "" })));
};
const styles = StyleSheet.create({
    slot: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 18,
        height: 18,
        flexShrink: 0,
    },
    icon: {
        width: 14.1429,
        height: 14.1429,
    },
});
